import React from "react";

export default function Footer() {
  return (
    <div className="container-fluid">
      <div className="container text-dark">
        <div>
          <p>Questions? Call 1-800-818-767</p>
        </div>
        <div className="row d-flex ">
          <div className="col-lg-3 col-xl-3 col-md-3 col-sm-6 col-xs-6 mt-2">
            <ul className="list-group">
              <li>FAQ</li>
              <li>Investor Relations</li>
              <li>Ways to Watch</li>
              <li>Corporate Information</li>
              <li>Netflix Originals</li>
            </ul>
          </div>

          <div className="col-lg-3 col-xl-3 col-md-3 col-sm-6 col-xs-6 mt-2">
            <ul className="list-group">
              <li>Help Center</li>
              <li>Jobs</li>
              <li>Terms of Use</li>
              <li>Contact Us</li>
            </ul>
          </div>
          <div className="col-lg-3 col-xl-3 col-md-3 col-sm-6 col-xs-6 mt-2">
            <ul className="list-group">
              <li>Account</li>
              <li>Redeem Gift Cards</li>
              <li>Privacy</li>
              <li>Speed Test</li>
            </ul>
          </div>
          <div className="col-lg-3 col-xl-3 col-md-3 col-sm-6 col-xs-6 mt-2">
            <ul className="list-group">
              <li>Media Center</li>
              <li>Buy Gift Cards</li>
              <li>Cookie Preferences</li>
              <li>Legal Notices</li>
            </ul>
          </div>
        </div>
        <div className="mt-5">
          <p>Netflix Malaysia</p>
        </div>
      </div>
    </div>
  );
}
